<template>
  <v-app>
    <v-snackbar v-model="snackbar" :timeout="11000">
      {{ msg }}
      <v-btn dark flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-container class="grey lighten-5">
      <v-row class="justify-center">
        <div class="d-flex justify-center align-center flex-column" v-if="isLoading">
          <p>Carregando...</p>
          <v-progress-circular indeterminate color="primary" class="mb-0"></v-progress-circular>
        </div>
        <v-col class="col-12 col-md-10" v-if="!isLoading">
          <h2 class="text-center text-md-left primary--text ml-md-4">
            <v-icon class="primary--text mr-2">calendar_today</v-icon>Detalhe da Consulta
          </h2>

          <div class="row justify-center">
            <div class="col-12 col-md-5">
              <div
                class="box-item custom-radius bg-yellow d-flex flex-row align-center justify-space-between px-3 py-4"
              >
                <div class="d-flex flex-row align-center justify-center">
                  <v-icon class="primary--text mr-2">record_voice_over</v-icon>
                  <p class="ma-0 mr-2 gray--text">{{details.psychologist.name}}</p>
                </div>
                <v-btn class="bt-perfil" @click="goProfilePsi(details.psychologist.id)">Ver Perfil</v-btn>
              </div>
              <div
                class="box-item border-bottom d-flex flex-row align-center justify-space-between px-3 py-4"
              >
                <div class="d-flex flex-row align-center justify-center">
                  <v-icon class="primary--text mr-2">calendar_today</v-icon>
                  <p class="ma-0 mr-2 gray--text">{{ details.date | formatDate }}</p>
                </div>
                <div class="d-flex flex-row align-center justify-center">
                  <v-icon class="primary--text mr-2">access_time</v-icon>
                  <p class="ma-0 mr-2 gray--text">{{ details.time | formatDateTZ(details.date) }}</p>
                </div>
              </div>
              <div
                class="box-item bg-gray d-flex flex-row align-center justify-center pa-3 mt-3 custom-radius"
              >
                <!-- <v-icon class="secondary--text mr-2">attach_money</v-icon> -->
                <p class="ma-0 mr-2 gray--text">
                  <strong>Valor da Consulta:</strong>
                </p>
                <p class="ma-0 mr-2 secondary--text valor-consulta">{{value}}</p>
              </div>
            </div>
            <div class="col-12 col-md-5">
              <p class="ma-0 mr-2 gray--text text-center text-md-left">
                <strong>{{$t('pageConsulta.titleContato')}}</strong>
              </p>
              <div
                class="box-item bg-gray custom-radius d-flex flex-row align-center justify-space-start px-3 py-4"
              >
                <p class="ma-0 gray--text">
                  <strong>Email</strong>
                </p>
                <v-icon class="gray--text ml-2" size="30">email</v-icon>
                <p class="ma-0 ml-2 gray--text text-center">
                  <strong>{{details.psychologist.email}}</strong>
                </p>
              </div>
            </div>
          </div>
          <div class="row justify-center align-center">
            <!-- REAGENDAR -->
            <div
              class="col-12 col-md-3 text-center"
              v-if="details.status == 'SCHEDULED' && details.date > date"
            >
              <v-row justify="center">
                <v-dialog v-model="dialog" max-width="400">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="gray"
                      v-on="on"
                      class="white--text"
                      height="50"
                      min-width="100%"
                    >Reagendar</v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="headline">Reagendar consulta!</v-card-title>
                    <v-card-text>
                      <div class="text-center">
                        <p>Informe aqui o motivo do reagendamento.</p>
                        <v-textarea
                          solo
                          flat
                          no-resize
                          background-color="#F7F7F7"
                          rows="8"
                          v-model="justification"
                        ></v-textarea>
                      </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="justify-end">
                      <!-- <v-btn color="gray darken-1" text @click="dialog = false">Não Obrigado</v-btn> -->
                      <v-btn
                        color="primary darken-1"
                        text
                        :disabled="isDisabled"
                        @click="rescheduleConsultation()"
                      >Ok</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </div>
            <!-- <div
              class="col-12 col-md-3 text-center"
              v-if="details.date >= date && details.time > time"
            >
              <v-btn color="primary" height="50" min-width="100%">Cancelar</v-btn>
            </div>-->
            <!-- FINALIZAR -->
            <div
              class="col-12 col-md-3 text-center"
              v-if="details.status == 'SCHEDULED' && details.dateTime <= nowDateTime && isIframeOpen === false"
            >
              <v-btn
                color="primary"
                height="50"
                min-width="100%"
                @click="doneConsultation()"
              >Finalizar</v-btn>
            </div>
            <!-- Avaliar  -->
            <div
              class="col-12 col-md-3 text-center"
              v-if="details.status == 'CLOSED' && details.assessment == null"
            >
              <v-row justify="center">
                <v-dialog v-model="dialog" max-width="400">
                  <template v-slot:activator="{ on }">
                    <v-btn color="secondary" dark v-on="on" height="50" min-width="100%">Avaliar</v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="headline">Avaliar atendimento!</v-card-title>
                    <v-card-text>
                      <div class="text-center">
                        Avalie aqui o seu atendimento.
                        <v-rating
                          v-model="rating"
                          color="red lighten-2"
                          background-color="gray lighten-1"
                          hover
                          class="my-3"
                        ></v-rating>
                        <p v-if="isInvalid" class="red--text">Defina uma quantidade de estrelas.</p>
                        <v-textarea
                          solo
                          flat
                          no-resize
                          background-color="#F7F7F7"
                          rows="8"
                          v-model="comments"
                        ></v-textarea>
                      </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="justify-space-between">
                      <v-btn color="gray darken-1" text @click="dialog = false">Não Obrigado</v-btn>

                      <v-btn color="primary darken-1" text @click="evaluate()">Avaliar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row class="iframe" v-if="isIframeOpen">
        <iframe
          :src="`${videoCall.video_call_url}?embed&iframeSource=ondivan&displayName=${details.patient_name}&screenshare=off&background=off`"
          :style="{width: '100%', height: '120%', backgroundImage: `url(${require('../../assets/icon_ondivan_red.svg')})`,backgroundSize: 'cover'}"
          allow="camera, microphone, fullscreen, speaker"
        />
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import http from '@/services/httpClient';
import momentTimezone from 'moment-timezone';

export default {
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      time: new Date().toTimeString().substr(0, 8),
      nowDateTime: new Date().toISOString().substr(0, 19),
      cod: '',
      details: {
        assessment: {},
        date: String,
        id: String,
        patient: String,
        patient_name: String,
        psychologist: {},
        status: String,
        time: String,
      },
      value: '',
      isLoading: false,
      dialog: false,
      rating: 0,
      comments: '',
      justification: '',
      videoCall: {
        video_call_url: String,
        video_call_status: String,
        video_call_id: Number,
      },
      isIframeOpen: false,
      isInvalid: false,
      isDisabled: true,
      snackbar: false,
      msg: '',
    };
  },
  async created() {
    await this.getCod();
    await this.getDetails();
    this.getVideoCallStatus();

    const secondsToUpdate = 25 * 1000;
    setInterval(() => this.getVideoCallStatus(), secondsToUpdate);
  },
  watch: {
    rating(val) {
      if (val > 0) {
        this.isInvalid = false;
      }
    },
    justification(val) {
      val ? (this.isDisabled = false) : (this.isDisabled = true);
    },
  },
  methods: {
    getCod() {
      this.cod = localStorage.getItem('user-id');
    },
    async getDetails() {
      this.isLoading = true;
      const { id } = this.$route.params;
      await http
        .get(`/patients/${this.cod}/appointments/${id}/`, {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        })
        .then((response) => {
          const { data } = response;
          this.details = data;
          this.value = data.psychologist.appointment_br_value == '0.00'
            ? `€ ${data.psychologist.appointment_pt_value}`
            : `R$ ${data.psychologist.appointment_br_value}`;
          this.details.dateTime = data.date.concat('T', data.time);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async getVideoCallStatus() {
      const videoResult = await http.get(
        `/appointments/${this.details.id}/video_call`,
        {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        },
      );
      this.videoCall = videoResult.data;
      if (videoResult.data.video_call_status === 'OPEN') {
        this.isIframeOpen = true;
      }
      if (
        this.isIframeOpen === true
        && videoResult.data.video_call_status === 'CLOSED'
      ) {
        this.msg = 'Sua consulta foi finalizada.';
        this.snackbar = true;
        this.isIframeOpen = false;
        this.getDetails();
      }
    },
    goProfilePsi(id) {
      this.$router.push({ name: 'PsicologoProfile', params: { id } });
    },
    doneConsultation() {
      this.dialog = true;
      http
        .post(
          `/patients/${this.cod}/appointments/${this.details.id}/closing/`,
          {},
          {
            headers: {
              Authorization: `Token ${localStorage.getItem('user-token')}`,
            },
          },
        )
        .then((response) => {
          const { data, status } = response;
          if (status == 200) {
            this.details = data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    rescheduleConsultation() {
      http
        .post(
          `/patients/${this.cod}/appointments/${this.details.id}/cancellation/`,
          {
            comments: this.justification,
          },
          {
            headers: {
              Authorization: `Token ${localStorage.getItem('user-token')}`,
            },
          },
        )
        .then((response) => {
          const { data, status } = response;
          if (status == 200) {
            this.details = data;
            this.$router.replace(
              `/psicologo/scheduling/${this.details.psychologist.id}`,
            );
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async evaluate() {
      if (this.rating == 0) {
        this.isInvalid = true;
        return;
      }
      await http
        .post(
          `/patients/${this.cod}/appointments/${this.details.id}/assessment/`,
          {
            rating: this.rating,
            comments: this.comments,
          },
          {
            headers: {
              Authorization: `Token ${localStorage.getItem('user-token')}`,
            },
          },
        )
        .then((response) => {
          const { data, status } = response;
          if (status == 200) {
            console.log(data);
            this.details = data;
            this.snackbar = true;
            this.msg = 'Avaliação enviada com sucesso!';
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.dialog = false;
        });
    },
    // formatDateTime: async function(date, time) {
    //   let data_user = localStorage.getItem('user-data');
    //   let timeZone = await JSON.parse(data_user).time_zone_name;
    //   let timetz = await momentTimezone.utc(`${date} ${time}`).tz(`${timeZone}`).format('HH:mm:ss');

    //   this.details.dateTime = date.concat('T',time);

    //   console.log(this.details.dateTime <= this.nowDateTime);
    // }
  },
};
</script>

<style lang="css" scoped>
.toolbar {
  height: auto;
}

.v-toolbar__content {
  height: auto !important;
}

.my__toolbar {
  height: auto;
}

.box-item {
  width: 100%;
}

.custom-radius {
  border-radius: 5px;
}

.bg-yellow {
  background-color: #fffde3;
}

.bg-gray {
  background-color: #e0e0e0;
}

.border-bottom {
  border-bottom: 1px solid #ccc;
}

.bt-perfil {
  font-size: 0.5rem;
}

.obs-text {
  font-size: 0.8rem;
}

.valor-consulta {
  font-size: 1.3rem;
}

.whats-img,
.whats-img .v-image__image--cover {
  width: 25px;
  height: 25px;
}

.skype-img,
.skype-img .v-image__image--cover {
  width: 25px;
  height: 25px;
}

.email-img,
.email-img .v-image__image--cover {
  width: 30px;
  height: 30px;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.iframe {
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 420px) {
  .my__toolbar img {
    width: 50%;
  }
}
</style>
